import React from 'react';

const RequiredSign = () => {
  return <span className="arf-single-asterisk">*</span>;
};

export default RequiredSign;
